import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getSellerFullDetails } from "../../../Redux/publicseller-apis-for-bookings/slice";
import { RootState, AppDispatch } from "../../../store";
import CategoriesBar from "../../globalcomponents/navbar/categorieslist/CategoriesBar";
import Navbar from "../../globalcomponents/navbar/Navbar";

const DoctorPro = () => {
  const { sellerId } = useParams<{ sellerId: string }>();
  const dispatch = useDispatch<AppDispatch>();
  const { selectedSeller, loading } = useSelector((state: RootState) => state.segment);

  useEffect(() => {
    if (sellerId) {
      dispatch(getSellerFullDetails(sellerId));
    }
  }, [dispatch, sellerId]);

  if (loading) {
    return (
      <>
        <Navbar />
        <CategoriesBar />
        <div className="text-center p-5">Loading Consultation details...</div>
      </>
    );
  }

  if (!selectedSeller) {
    return (
      <>
        <Navbar />
        <CategoriesBar />
        <div className="text-center p-5 text-muted h5">Consultation not found.</div>
      </>
    );
  }

  const { businessInfo, banners, digitalProducts, descriptions } = selectedSeller;
  const name = typeof selectedSeller.sellerId === "object" ? (selectedSeller.sellerId as any)?.name : (selectedSeller.sellerId || "Consultation");
  const firstProductId = digitalProducts?.[0]?._id || "none";

  const DoctorCard = ({ isMobile = false }) => {
    const details = businessInfo?.businessInfo || {};
    
    return (
      <div className={`card shadow-dark border-radius-lg p-3 ${isMobile ? "border w-97 mx-auto" : ""}`}>
        <img
          src={banners?.[0]?.url || "../../assets/img/team-2.jpg"}
          alt={name}
          className="img-fluid border-radius-section"
          style={{ width: isMobile ? "100px" : "120px", height: isMobile ? "100px" : "120px", objectFit: "cover" }}
        />
        <div className="mt-2 lh-sm">
          <b className={`text-black fw-bold letter-spacing-1 fs-style-2 ${isMobile ? "fs-5" : "fs-4"}`}>
            {name}
          </b>
          {details.degrees && (
            <div>
              <b className="text-black-50 fw-bold text-xs letter-spacing-1">
                {details.degrees}
              </b>
            </div>
          )}
        </div>

        {details.department && (
          <div className="mt-2">
            <b className="text-black fw-bolder text-md letter-spacing-1 fs-style-3">
              Department : <b className="text-black fw-normal text-md">{details.department}</b>
            </b>
          </div>
        )}
        
        {details.experience && (
          <div className="mt-1">
            <b className="text-black fw-bolder text-md letter-spacing-1 fs-style-3">
              Exp : <b className="text-black fw-normal text-md">{details.experience} yrs</b>
            </b>
          </div>
        )}

        {(businessInfo?.consultantType || details.ownershipType) && (
          <div className="mt-1">
            <b className="text-black fw-bolder text-md letter-spacing-1 fs-style-3">
              Designation : <b className="text-black fw-normal text-md">{businessInfo?.consultantType || details.ownershipType}</b>
            </b>
          </div>
        )}

        {businessInfo?.languages && businessInfo.languages.length > 0 && (
          <div className="mt-1">
            <b className="text-black fw-bolder text-md letter-spacing-1 fs-style-3">
              Languages : <b className="text-black fw-normal text-md">{businessInfo.languages.join(", ")}</b>
            </b>
          </div>
        )}

        {businessInfo?.registrationNumber && (
          <div className="mt-1">
            <b className="text-black fw-bolder text-md letter-spacing-1 fs-style-3">
              Med Reg No : <b className="text-black fw-normal text-md">{businessInfo.registrationNumber}</b>
            </b>
          </div>
        )}

        {businessInfo?.opdTiming && (
          <div className="mt-1">
            <b className="text-black fw-bolder text-md letter-spacing-1 fs-style-3">
              Day time OPD:
              <div>
                <b className="text-black fw-normal text-md">
                  {businessInfo.opdTiming}
                </b>
              </div>
            </b>
          </div>
        )}

        {details.city && (
          <div className="mt-1">
            <b className="text-black fw-bolder text-md letter-spacing-1 fs-style-3">
              Location : <b className="text-black fw-normal text-md">{details.city}</b>
            </b>
          </div>
        )}

        <div className={`w-100 text-start mt-3 ${isMobile ? "d-flex gap-1" : ""}`}>
          <div>
            <Link to={`/CustomerDetails/${sellerId}/${firstProductId}`}>
              <button className={`btn btn-outline-dark btn-md border-radius-40 mb-2 ${isMobile ? "w-100" : "w-70"}`}>
                Book An Appointment
              </button>
            </Link>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {/* Desktop View */}
      <div className="display-max">
        <Navbar />
        <CategoriesBar />
        <div className="container w-65 mt-3">
          <div className="d-flex justify-content-between align-items-center">
           
          </div>
          <div className="mt-4 mb-4">
            <div className="d-flex justify-content-start align-items-start gap-3">
              <div className="w-50">
                <DoctorCard />
              </div>
              <div className="w-100">
                {descriptions && descriptions.length > 0 ? (
                  descriptions.map((desc: any) => (
                    <div className="card shadow-dark border-radius-lg p-3 mb-3" key={desc.id || desc._id}>
                      <b className="text-black fs-3 fw-normal letter-spacing-1 fs-style-2">{desc.keyword}</b>
                      <div className="mt-2 mb-3">
                        {desc.type === "Bullet Points" ? (
                          <ul className="text-black fw-normal text-md letter-spacing-1 fs-style-3 mb-0 ps-3">
                            {desc.content.split("\n").map((line: string, i: number) => (
                              <li key={i}>{line.trim()}</li>
                            ))}
                          </ul>
                        ) : (
                          <b className="text-black fw-normal text-md letter-spacing-1 fs-style-3" style={{ whiteSpace: "pre-line" }}>
                            {desc.content}
                          </b>
                        )}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="card shadow-dark border-radius-lg p-3">
                    <b className="text-black fs-3 fw-normal letter-spacing-1 fs-style-2">About the Consultation</b>
                    <div className="mt-2 mb-3">
                      <b className="text-black fw-normal text-md letter-spacing-1 fs-style-3">
                        {businessInfo?.about || `Experience professional consultation with ${name}.`}
                      </b>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile View */}
      <div className="display-mini display-mob pb-7">
        <Navbar />
        <div className="pt-8">
          <div className="w-97 mx-auto">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb bg-white gap-1">
                <li className="breadcrumb-item"><Link to="/BookAppointmentList" className="text-xxs">Book An Appointment</Link></li>
                <li className="breadcrumb-item active"><b className="text-xxs">{name}</b></li>
              </ol>
            </nav>
            <DoctorCard isMobile />
            <div className="mt-4 mb-4">
              {descriptions && descriptions.length > 0 ? (
                descriptions.map((desc: any) => (
                  <div className="card shadow-dark border-radius-lg p-3 mb-3" key={desc.id || desc._id}>
                    <b className="text-black fs-3 fw-normal letter-spacing-1 fs-style-2">{desc.keyword}</b>
                    <div className="mt-2 mb-3">
                      {desc.type === "Bullet Points" ? (
                        <ul className="text-black fw-normal text-md letter-spacing-1 fs-style-3 mb-0 ps-3">
                          {desc.content.split("\n").map((line: string, i: number) => (
                            <li key={i}>{line.trim()}</li>
                          ))}
                        </ul>
                      ) : (
                        <b className="text-black fw-normal text-md letter-spacing-1 fs-style-3" style={{ whiteSpace: "pre-line" }}>
                          {desc.content}
                        </b>
                      )}
                    </div>
                  </div>
                ))
              ) : (
                <div className="card shadow-dark border-radius-lg p-3">
                  <b className="text-black fs-3 fw-normal letter-spacing-1 fs-style-2">About the Consultation</b>
                  <div className="mt-2 mb-3">
                    <b className="text-black fw-normal text-md letter-spacing-1 fs-style-3">
                      {businessInfo?.about}
                    </b>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DoctorPro;
